import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  editor?: object;
  header: {
    imageUrl: string;
    imageAlt: string;
    title: string;
    subtitle: string;
  };
  gridSection: {
    sections: {
      title: string;
      subtitle: string;
    }[];
  };
  blockSection: {
    title: string;
    sections: {
      imageUrl: string;
      imageAlt: string;
      title: string;
      subtitle: string;
    }[];
  };
}

const propsSchema: PropsSchemaList = [
  {
    key: 'header',
    label: 'Header',
    type: types.OBJECT,
    children: [
      {
        key: 'imageUrl',
        label: 'Image URL',
        type: types.S3_ASSET_URL,
      },
      {
        key: 'imageAlt',
        label: 'Image Alternative Text (A brief description of the image to optimize search engine visibility)',
        type: types.TEXT,
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'subtitle',
        label: 'Subtitle',
        type: types.TEXT,
      }
    ]
  },
  {
    key: 'gridSection',
    label: 'Grid Section',
    type: types.OBJECT,
    children: [
      {
        key: 'sections',
        label: 'Sections',
        type: types.ARRAY,
        children: [
          {
            key: 'title',
            label: 'Title',
            type: types.TEXT,
          },
          {
            key: 'subtitle',
            label: 'Subtitle',
            type: types.TEXT,
          }
        ]
      }
    ]
  },
  {
    key: 'blockSection',
    label: 'Block Section',
    type: types.OBJECT,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'sections',
        label: 'Sections',
        type: types.ARRAY,
        children: [
          {
            key: 'imageUrl',
            label: 'Image URL',
            type: types.S3_ASSET_URL,
          },
          {
            key: 'imageAlt',
            label: 'Image Alt Text (Description for Accessibility)',
            type: types.TEXT,
          },
          {
            key: 'title',
            label: 'Title',
            type: types.TEXT,
          },
          {
            key: 'subtitle',
            label: 'Subtitle',
            type: types.TEXT,
          }
        ]
      }
    ]
  },
];

const defaultProps: Props = {
  header: {
    imageUrl: 'https://genesis-cdn.ff.com/assets/pages/ff-labs/icons/chemistry_lab.svg',
    imageAlt: 'Chemistry lab',
    title: `Try FF's latest experiments in Labs`,
    subtitle: 'Collaborate in pioneering experiments to co-create the next wave of technological advancements.'
  },
  gridSection: {
    sections: [{
      title: 'Magic All-In-One Labs',
      subtitle: 'All-Terrain AI Body Control Technology System'
    }, {
      title: 'Hyper Multi-Vectoring Labs',
      subtitle: 'Integrated multi-axis torque technology system for AI propulsion, steering and braking'
    }, {
      title: '3rd aiSpace Labs',
      subtitle: 'AI Space & Internet Technology System'
    }, {
      title: 'FF aiDriving Labs',
      subtitle: 'aiDriving Technology System'
    }]
  },
  blockSection: {
    title: 'How it works',
    sections: [{
      imageUrl: 'https://genesis-cdn.ff.com/assets/pages/ff-labs/icons/tester.svg',
      imageAlt: 'Tester',
      title: 'Join as a pioneer tester',
      subtitle: 'Gain entry to exclusive experimental features.'
    }, {
      imageUrl: 'https://genesis-cdn.ff.com/assets/pages/ff-labs/icons/innovations.svg',
      imageAlt: 'Innovation',
      title: 'Explore AI innovations',
      subtitle: 'Discover fresh approaches to Google services.'
    }, {
      imageUrl: 'https://genesis-cdn.ff.com/assets/pages/ff-labs/icons/insights.svg',
      imageAlt: 'Insights',
      title: 'Offer your insights',
      subtitle: 'Contribute your thoughts to enhance our learning and drive innovation.'
    }]
  }
};

export default {
  title: 'Lab Heading',
  id: 'LabHeading',
  propsSchema,
  defaultProps,
}
